// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OrderSlTpBase } from './OrderSlTpBase';
export class StopLoss extends OrderSlTpBase {
    constructor() {
        super(...arguments);
        this.sllValue = null; // #91413
    }
}
